// src/components/atomicDesignDesktop/TextInputMobile.tsx
import React, { FC, useState } from 'react';

interface TextInputProps {
	width: string | number;
	title?: string;
	mandatory?: boolean;
	type: string;
	startIcon?: string;
	placeholder?: string;
	value: string;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	disabled?: boolean;
	loading?: boolean;
	wrong?: boolean;
	wrongMessage?: string;
}

const TextInputLaptop: FC<TextInputProps> = ({
	width,
	title,
	mandatory,
	type,
	startIcon,
	placeholder,
	value,
	onChange,
	disabled,
	loading,
	wrong,
	wrongMessage,
}) => {
	const [showPassword, setShowPassword] = useState(false);
	const handleClickShowPassword = () => setShowPassword(!showPassword);
	
	const inputType = type === 'password' && showPassword ? 'text' : type;
	
	return (
		<div style={{ width: width, position: 'relative' }}
		>
			{title && (
				<div
					style={{
						marginBottom: 4,
						fontWeight: '600',
						fontSize: 16,
						color: '#323E48',
					}}
				>
					{title} {mandatory && '*'}
				</div>
			)}
			<div
				style={{
					height: 48,
					background: disabled ? "#EDEDED" : '#FFFFFF',
					boxShadow: '0px 1px 6px #00000029',
					borderRadius: 10,
					border: wrong ? '2px solid red' : '1px solid #00000029',
					display: 'flex',
					alignItems: 'center',
					padding: '0 10px',
					boxSizing: 'border-box',
					cursor: disabled ? 'not-allowed' : 'pointer',
				}}
			>
				{startIcon && (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							fontSize: '18px',
							color: '#cccccc',
							width: 60,
						}}
					>
						{startIcon.length > 1 ? (
							<img
								src={startIcon}
								alt="icon"
								style={{ width: 32, height: 32 }}
							/>
						) : (
							<div
								style={{
									width: 32,
									height: 32,
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									fontSize: 25,
									color: '#969DA2',
									marginTop: -5,
								}}
							>
								{startIcon}
							</div>
						)}
					</div>
				)}
				{loading &&
					<img
						src="/images/loading.gif"
						alt="loading"
						style={{
							position: 'absolute',
							right: 0,
							width: 55,
							height: 55
						}}
					/>
				}
				<input
					type={inputType}
					placeholder={placeholder ? placeholder : ''}
					value={value}
					onChange={disabled ? () => {} : onChange}
					className="custom-input"
					style={{
						maxWidth:'95%',
						border: 'none',
						outline: 'none',
						fontSize: 19,
						color: '#323E48',
						background: disabled ? '#EDEDED' : 'none',
						flex: 1,
						cursor: disabled ? 'not-allowed' : 'text',
					}}
				/>
				{type === 'password' && (
					<button
						onClick={handleClickShowPassword}
						style={{
							background: 'none',
							border: 'none',
							cursor: 'pointer',
							display: 'flex',
							alignItems: 'center',
							color: showPassword ? '#FF4D00' : '#cccccc',
						}}
					>
						{showPassword ? (
							<img
								src="/images/password-visible.svg"
								alt="eye"
								style={{ width: 32, height: 32 }}
							/>
						) : (
							<img
								src="/images/password-hidden.svg"
								alt="eye"
								style={{ width: 32, height: 32 }}
							/>
						)}
					</button>
				)}
				{wrong && (
					<div
						style={{
							position: 'absolute',
							bottom: -20,
							left: 5,
							fontSize: 12,
							color: 'red',
						}}
					>
						{wrongMessage}
					</div>
				)}
			</div>
		</div>
	);
};

export default TextInputLaptop;
